"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
function TableBody({ page, prepareRow, wrapText = true, reactTableBodyProps, styles, }) {
    return (react_1.default.createElement(core_1.TableBody, Object.assign({}, reactTableBodyProps), page
        .map((row) => {
        prepareRow(row);
        return row;
    })
        .map((row) => (react_1.default.createElement(core_1.TableRow, Object.assign({ selected: row.isSelected }, row.getRowProps(), { className: clsx_1.default({ [styles.aggregated]: row.isGrouped }) }), row.cells.map((cell) => {
        return (react_1.default.createElement(core_1.TableCell, Object.assign({}, cell.getCellProps()), cell.isGrouped ? (react_1.default.createElement("div", { className: styles.cellAlign },
            react_1.default.createElement("span", { className: clsx_1.default({ [styles.ellipsizeText]: !wrapText }) },
                react_1.default.createElement("b", null,
                    cell.render('Cell'),
                    " (",
                    row.subRows.length,
                    ")")),
            row.isExpanded ? (react_1.default.createElement(icons_1.KeyboardArrowDown, Object.assign({}, row.getToggleRowExpandedProps()))) : (react_1.default.createElement(icons_1.KeyboardArrowRight, Object.assign({}, row.getToggleRowExpandedProps()))))) : (
        // If the cell is aggregated, use the Aggregated
        // renderer for cell, otherwise, just render the regular cell
        react_1.default.createElement("div", { className: clsx_1.default({ [styles.ellipsizeText]: !wrapText }) }, cell.render(cell.isAggregated ? 'Aggregated' : 'Cell')))));
    }))))));
}
exports.default = TableBody;
//# sourceMappingURL=index.js.map